import React from 'react';

export function ProfileHeader() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 style={{ 
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'var(--admin-card-text)', 
          fontSize: '37.9px', 
          fontWeight: 700, 
          margin: '0 0 6px', 
          letterSpacing: '-0.76px',
          lineHeight: '38px'
        }}>
          Profile
        </h1>
        <p style={{ 
          fontFamily: "'Inter', sans-serif",
          color: '#7C8891', 
          fontSize: '14px', 
          margin: 0, 
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '0'
        }}>
          Manage your personal details, workspace options, and password security.
        </p>
      </div>
    </div>
  );
}
